export default function secureRandomHexString(numBytes) {
  const randomBytes = new Uint8Array(numBytes);
  window.crypto.getRandomValues(randomBytes);
  return randomBytes.reduce(
    (str, byte) => str + `0${byte.toString(16)}`.slice(-2),
    ''
  );
}
